import React from 'react';
import { replaceTemplateTags } from '../../helpers/replaceTemplateTags';
import './styling.css';

function FooterComponent({
  question,
  branchMetadata,
  isChild,
  dniPhoneNumber,
}) {
  const text = replaceTemplateTags(question.Text || '', branchMetadata);

  // Extract phone number from text if present
  const phoneMatch = text.match(/(\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})/);

  if (phoneMatch) {
    const phoneNumber = phoneMatch[1];
    const beforePhone = text.substring(0, phoneMatch.index).trim();
    const afterPhone = text
      .substring(phoneMatch.index + phoneNumber.length)
      .trim();

    // Use stored DNI phone number if available, otherwise use original
    const displayPhone = dniPhoneNumber || phoneNumber;

    // Clean phone number for tel: link (remove formatting)
    const telLink = displayPhone.replace(/[^\d]/g, '');

    return (
      <footer className="shared-padding footer-component">
        <span className="footer-content">
          <span role="img" aria-label="phone">
            📞
          </span>
          {beforePhone && `${beforePhone} `}
          <a
            href={`tel:${telLink}`}
            data-st-phone={displayPhone}
            className="dni-phone"
          >
            {displayPhone}
          </a>
          {afterPhone && ` ${afterPhone}`}
        </span>
      </footer>
    );
  }

  return (
    <footer className="shared-padding footer-component">
      <span className="footer-content">{text}</span>
    </footer>
  );
}

export default FooterComponent;
